import React from 'react';
import './About.css';
import insta from '../image/insta.png';
import fb from '../image/fb.png';
import twitter from '../image/twitter.png';
import pic1 from '../image/pic1.jpeg';


const About = props => {
    return (
        <div className="main_containt2">
           <div className="Jumbotron2"> 
               
                 {/*<div className="shape_circle"></div>
                 <div className="shape_penta"></div>*/}
            
               <h1>About Us</h1>
               <hr className="hr"/>
               <p>RishiQuote is a Instagram page founded in November, 2017 where you can find 
                  Urdu & Hindi Gazal, Shayari & Poetry.</p>
                <p>All the containt of RishiQuote you find here or on any other platform is purely copyrighted and original.</p>
               <p>This WebSite is created in January, 2020.</p>
            
           </div>
           <div className="cr2">
      <div className="circle"></div>
        <div className="rect"></div>
        <img className="imgf" src={pic1} />
        <h4 className="nm">RishiQuote | رشی راج </h4>
        <p>&copy; 2020 - 2021 <a href="/">Privacy Policies</a></p>
        <div className="row2">
          <div className="column2">
            <p className="sh">SHARING</p>
          </div>
          <div className="column2">
            <p className="sh">NETWORKING</p>
          </div>
          <div className="column2">
            <p className="sh">LINKS</p>
          </div>
        </div>
        <div className="row1">
          <div className="column1">
            <a href="https://www.instagram.com/rishiquote">
              <img src={insta} />
            </a>
          </div>
          <div className="column1">
            <a href="https://www.facebook.com/rishiquote">
              <img src={fb} />
            </a>
          </div>
          <div className="column1">
            <img src={twitter} />
          </div>
        </div>
        <div className="ty">
          <p>Gazal</p>
          <p>Shayari</p>
          <p>Poetry</p>
        </div>
      </div>
        </div>
    );
    };
export default About;